export interface LogSyncStep {
  success: boolean;
  statusCode: number;
  namespace: string;
  stepName: string;
  outcome: string;
  error: string;
}

// When the sync ran. Recorded at the top level of every item, for both shapes; logs written before
// the sync started recording timing don't have it.
export interface LogSyncTiming {
  startedAt?: string;
  endedAt?: string;
  durationSeconds?: number;
}

export interface LogSyncResults extends LogSyncTiming {
  success: boolean;
  statusCode: number;
  error: string;
  steps: LogSyncStep[];
}

export interface LogSyncReference {
  id: string;
  name: string;
}

// Some sync types record one result per connection/site, with the actual
// outcome nested under `results`; others record a single flat result
// directly. Both shapes come from the same collection depending on the
// producing sync job, so the detail view branches on `isConnectionItem`
// rather than on the log's `name`.
export interface LogSyncConnectionItem extends LogSyncTiming {
  connection: LogSyncReference;
  site: LogSyncReference;
  counters: Record<string, number>;
  results: LogSyncResults;
}

export type LogSyncItem = LogSyncResults | LogSyncConnectionItem;

export interface LogSyncDetail {
  id: string;
  name: string;
  createdAt: string;
  item: LogSyncItem;
}

export const isConnectionItem = (
  item: LogSyncItem,
): item is LogSyncConnectionItem =>
  Object.prototype.hasOwnProperty.call(item, 'connection');
